import React from "react";

import { LogoWrapper } from "./styles";

export function Logo() {
  return (
    <LogoWrapper>
      <svg
        width="138"
        height="65"
        viewBox="0 0 138 65"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_5178_13607)">
          <g clipPath="url(#clip1_5178_13607)">
            <path
              d="M137.06 35.6993H128.284L128.251 47.9426C128.251 53.8299 133.285 55.0261 137.105 55.1836C137.605 55.2061 138 55.6223 138 56.1211V64.052C138 64.5845 137.564 65.0045 137.026 64.9932C130.413 64.8357 124.908 63.0508 121.622 59.6872C117.028 54.9773 117.133 49.5963 117.167 49.1238L117.264 15.2851C117.264 14.7676 117.686 14.3477 118.204 14.3477H127.416C127.939 14.3477 128.36 14.7714 128.356 15.2926L128.277 26.4184H137.052C137.571 26.4184 137.992 26.8384 137.992 27.3559V34.7581C137.992 35.2756 137.571 35.6956 137.052 35.6956L137.06 35.6993Z"
              fill="white"
            />
            <path
              d="M56.3936 62.5825L56.42 9.35332C56.42 8.83584 55.9989 8.41211 55.48 8.41211H46.2534C45.7346 8.41211 45.3135 8.83209 45.3135 9.34957V62.5788C45.3135 63.0963 45.7346 63.5162 46.2534 63.5162H55.4574C55.9763 63.5162 56.3974 63.0963 56.3974 62.5788L56.3936 62.5825Z"
              fill="white"
            />
            <path
              d="M105.666 41.7861C102.842 40.7287 99.0973 39.9262 95.7849 39.3862C94.1456 39.0975 92.8372 38.6775 91.8898 38.1338C90.273 37.3126 90.2505 34.7664 91.8446 33.8402C93.6531 32.614 98.0709 32.7302 99.9395 34.1064C100.654 34.5302 101.229 35.3026 101.639 36.2288C101.778 36.5401 102.124 36.7013 102.451 36.6038L110.764 34.0802C111.32 33.9114 111.584 33.289 111.335 32.7677C110.29 30.5553 108.662 28.6804 106.436 27.1954C101.007 23.2881 89.8106 23.3443 84.6145 27.3979C79.9599 30.3941 78.7981 38.5913 82.3962 42.8173C85.4379 46.436 90.3482 47.7372 95.1082 48.7384L95.157 48.7459C97.2249 49.0684 100.763 49.7621 101.88 50.587C103.647 51.6408 103.462 54.0782 101.767 55.2106C100.816 55.9118 99.2778 56.2643 97.1986 56.2643C93.1794 56.2568 90.4911 54.7981 89.2767 51.427C89.1639 51.112 88.803 50.917 88.4759 51.0033L80.099 53.1669C79.5801 53.3019 79.2756 53.8382 79.4297 54.3481C80.3697 57.3893 82.1894 59.9129 84.8552 61.6904C93.811 67.6901 113.783 66.1489 113.49 52.0945C113.49 49.3533 112.768 47.1334 111.347 45.4985C109.952 43.8973 108.042 42.6523 105.666 41.7936V41.7861Z"
              fill="white"
            />
            <path
              d="M73.3506 24.9258H63.9849C63.4658 24.9258 63.0449 25.3455 63.0449 25.8632V62.5856C63.0449 63.1033 63.4658 63.523 63.9849 63.523H73.3506C73.8697 63.523 74.2905 63.1033 74.2905 62.5856V25.8632C74.2905 25.3455 73.8697 24.9258 73.3506 24.9258Z"
              fill="white"
            />
            <path
              d="M68.6687 12.2179C65.2848 12.2179 62.5439 9.48425 62.5439 6.10938V12.5591C62.5439 15.934 65.2848 18.6676 68.6687 18.6676C72.0525 18.6676 74.7934 15.934 74.7934 12.5591V6.10938C74.7934 9.48425 72.0525 12.2179 68.6687 12.2179Z"
              fill="#F0A028"
            />
            <path
              d="M74.767 6.68052C75.083 3.32164 72.609 0.343247 69.2412 0.0281043C65.8734 -0.287038 62.8871 2.1804 62.5712 5.53929C62.2552 8.89818 64.7292 11.8766 68.097 12.1917C71.4648 12.5069 74.4511 10.0394 74.767 6.68052Z"
              fill="white"
            />
            <path
              d="M20.4007 24.3066C9.13257 24.3066 0 33.415 0 44.6534C0 55.8917 9.13257 65.0001 20.4007 65.0001C31.6689 65.0001 40.8014 55.8917 40.8014 44.6534C40.8014 33.415 31.6689 24.3066 20.4007 24.3066ZM20.4007 54.6392C14.87 54.6392 10.3883 50.1694 10.3883 44.6534C10.3883 39.1373 14.87 34.6675 20.4007 34.6675C25.9314 34.6675 30.4131 39.1373 30.4131 44.6534C30.4131 50.1694 25.9314 54.6392 20.4007 54.6392Z"
              fill="white"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_5178_13607">
            <rect width="138" height="65" fill="white" />
          </clipPath>
          <clipPath id="clip1_5178_13607">
            <rect width="138" height="65" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </LogoWrapper>
  );
}
